import { render, staticRenderFns } from "./ChartingLeftDrawerFavoritesSection.vue?vue&type=template&id=4ead8ecc&scoped=true&"
import script from "./ChartingLeftDrawerFavoritesSection.vue?vue&type=script&lang=js&"
export * from "./ChartingLeftDrawerFavoritesSection.vue?vue&type=script&lang=js&"
import style0 from "./ChartingLeftDrawerFavoritesSection.vue?vue&type=style&index=0&id=4ead8ecc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ead8ecc",
  null
  
)

export default component.exports